import { render } from "./crm-notifications.vue?vue&type=template&id=032df2dd"
import script from "./crm-notifications.vue?vue&type=script&lang=js"
export * from "./crm-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__